export class CameraMode {
    static NONE = 0;
    static INTRO = 1;
    static TRANSITION = 2;
    static GAME = 3;
}